import { Root, Icon, Text } from './styled-components';
const Badge = Root;
Badge.Icon = Icon;
Badge.Text = Text;
const BadgeMain = Badge;
export { BadgeMain as Badge, Icon as BadgeIcon, Text as BadgeText };
